module.exports = __webpack_public_path__ + "static/what-we-do-half-day-trainings-d38805c5672c7bd8317a0d9bedb3cff6.jpg";